import { render, staticRenderFns } from "./SuggestionBoard.vue?vue&type=template&id=2971d8ca&scoped=true&"
import script from "./SuggestionBoard.vue?vue&type=script&lang=js&"
export * from "./SuggestionBoard.vue?vue&type=script&lang=js&"
import style0 from "./SuggestionBoard.vue?vue&type=style&index=0&id=2971d8ca&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2971d8ca",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/piscinaFacilDev/piscinapp-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2971d8ca')) {
      api.createRecord('2971d8ca', component.options)
    } else {
      api.reload('2971d8ca', component.options)
    }
    module.hot.accept("./SuggestionBoard.vue?vue&type=template&id=2971d8ca&scoped=true&", function () {
      api.rerender('2971d8ca', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/analyzes/SuggestionBoard.vue"
export default component.exports